//
//
//
//

export default {
    name: "AcBreadcrumbsItem",
    props: {
        item: { type: Object, required: true }
    },
    computed: {
        itemClass() {
            const classes = ["ac-item"];
            if (this.item.link) {
                classes.push("link");
            }
            return classes;
        }
    },
    methods: {
        onClick() {
            const { link } = this.item;
            if (link) {
                this.$emit("goTo", link);
            }
        }
    }
};
